import callApi from "./../store/callApi";

const actions = {
    ...callApi,

    setLoadMore: ({ commit }, payload) => {
        commit("setLoadMore", payload);
    },
    setEndItemofPage: ({ commit }, payload) => {
        commit("setEndItemofPage", payload);
    },
    setLastPosition: ({ commit }, payload) => {
        commit("setLastPosition", payload);
    },
    resetPagination: ({ commit }) => {
        commit("resetPagination");
    },
    resetPaginationTemplate: ({ commit }) => {
        commit("resetPaginationTemplate");
    },
    toggleDisplayItem: ({ commit }, payload) => {
        commit("toggleDisplayItem", payload);
    },
    setFetching: ({ commit }, payload) => {
        commit("setFetching", payload);
    },

    // search list history
    openSearch: ({ commit }) => {
        commit("resetListHistory");
        commit("resetPagination");
        commit("setIsSearch", true);
        commit("setSearch", "");
        commit("setSearchLoading", false);
    },
    closeSearch: ({ commit, dispatch }, payload) => {
        commit("setIsSearch", false);
        commit("setSearch", "");
        commit("setSearchLoading", false);
        commit("resetListHistory");
        commit("resetPagination");
        dispatch("fetchListHistory", payload);
    },
    setSearch: ({ commit }, payload) => {
        commit("setSearch", payload);
    },
    doSearch: ({ commit, dispatch }, payload) => {
        commit("resetListHistory");
        commit("resetPagination");
        dispatch("fetchListHistory", payload);
    },
    loadingSearch: ({ commit }, payload) => {
        commit("setSearchLoading", payload);
    },

    // search template
    openSearchTemplate: ({ commit }) => {
        commit("resetListTemplate");
        commit("resetPaginationTemplate");
        commit("setIsSearch", true);
        commit("setSearch", "");
        commit("setSearchLoading", false);
    },
    closeSearchTemplate: ({ commit, dispatch }, payload) => {
        commit("setIsSearch", false);
        commit("setSearch", "");
        commit("setSearchLoading", false);
        commit("resetListTemplate");
        commit("resetPaginationTemplate");
        dispatch("fetchListTemplate", payload);
    },
    setSearchTemplate: ({ commit }, payload) => {
        commit("setSearch", payload);
    },
    doSearchTemplate: ({ commit, dispatch }, payload) => {
        commit("resetListTemplate");
        commit("resetPaginationTemplate");
        dispatch("fetchListTemplate", payload);
    },
    loadingSearchTemplate: ({ commit }, payload) => {
        commit("setSearchLoading", payload);
    },
    resetListTemplate: ({ commit }) => {
        commit("resetPaginationTemplate");
        commit("resetListTemplate");
    },
    resetListHistory: ({ commit }) => {
        commit("resetPagination");
        commit("resetListHistory");
    },
    setPayloadCreateBlast: ({ commit }, payload) => {
        commit("setPayloadCreateBlast", payload);
    },
    resetPayloadCreateBlast: ({ commit }) => {
        commit("resetPayloadCreateBlast");
    },
    resetListMessage: ({ commit }) => {
        commit("resetListMessage");
    },
};

export default actions;
